// extracted by mini-css-extract-plugin
export default {"holder":"Contact_holder__VICw-","title":"Contact_title__a0xQo","description":"Contact_description__lKURY"};